import IdeasToBuy from './components/pages/IdeasToBuy'
import About from './components/pages/About'
import Contact from './components/pages/Contact'
import Philosophy from './components/pages/Philosophy'
import Gallery from './components/pages/Gallery'
import GalleryDesktop from './components/pages/GalleryDesktop'
import Conseil from './components/pages/Conseil'

export default {
  title: 'Site title',
  description: `
    Digital art director based in Paris, France.<br/>
    Currently available for freelance projects.
  `,


  pages: [
    {
      index: 0,
      url: '/',
      title: 'Ideas to buy',
      isExact: true,
      component: IdeasToBuy
    },
    {
      index: 1,
      url: '/campagnes',
      title: 'Campagnes',
      component: Gallery,
      desktopComponent: GalleryDesktop,
      items: [
        {
          "title": "Luxe | Mode",
          "id": "luxe-mode",
          "image": "luxe.jpg",
          "items": [
            {
              "title": "Pequignet",
              "id": "pequignet",
              "date": "2O15",
              "context": "Campagne print pour les montres Pequignet.",
              "idea": "Illustrer le Savoir vivre à l’heure française.",
              "meta": [
                {
                  "name": "Directeur de Création",
                  "value": "Eric Hélias"
                },
                {
                  "name": "Direction Artistique",
                  "value": "Elodie Matyjasik"
                },
                {
                  "name": "Photographe",
                  "value": "Olivier Trillon"
                }
              ],
              "image": "luxe.jpg",
              "images": [

                { "src": "/images/projects/peguinet3.jpg"},
                { "src": "/images/projects/peguinet4.jpg"},
                { "src": "/images/projects/peguinet1.jpg"},
                { "src": "/images/projects/peguinet2.jpg"}
              ]
            }
          ]
        },
        {
          "title": "Grandes causes",
          "id": "grandes-causes",
          "image": "grandes-causes.jpg",
          "items": [
            {
              "title": "Nation Unies",
              "id": "nations-unies",
              "date": "2O15",
              "context": "Campagne de lutte contre le paludisme pour les Nations Unies.",
              "idea": "Un enfant africain, le petit Didier Drogba, rêve de devenir footballeur. Il devra d’abord livrer un match mortel contre les moustiques porteurs du paludisme.",
              "meta": [
                {
                  "name": "Formats",
                  "value": "30 sec, 1 minute, 2 minutes"
                },
                {
                  "name": "Directeur de Création",
                  "value": "Eric Hélias"
                },
                {
                  "name": "Direction Artistique",
                  "value": "Hervé Lopez"
                },
                {
                  "name": "Réalisation",
                  "value": "Jérémy Guerrieri"
                },
                {
                  "name": "Voix off",
                  "value": "Didier Drogba"
                }
              ],
              "image": "grandes-causes.jpg",
              "images": [
                { "src": "/images/projects/nations-unies.mp4"},
              ]
            },
          ]
        },
        {
          "title": "Medias",
          "id": "medias",
          "image": "medias.jpg",
          "items": [
            {
              "title": "LCP Politique",
              "id": "lcp",
              "date": "2O15",
              "context": "Campagne print / web de soutien éditorial pour La Chaine Parlementaire.",
              "idea": "Une journée dure 24H. La Politique aussi.",
              "meta": [
                {
                  "name": "Directeur de Création",
                  "value": "Eric Hélias"
                },
                {
                  "name": "Rédacteur",
                  "value": "Eric Hélias"
                },
                {
                  "name": "Direction Artistique",
                  "value": "Gregory Jeanjacquot"
                }
              ],
              "image": "medias.jpg",
              "images": [
                { "src": "/images/projects/lcpgeneriquehauteurjpg.jpg"},
                { "src": "/images/projects/lcpagendadeministre.jpg"},
                { "src": "/images/projects/lcpgenrique4X3.jpg"},
                { "src": "/images/projects/lcptwittez.jpg"},
              ]
            },
            {
              "title": "LCP Gomorra",
              "id": "lcp-gomorra",
              "date": "2O15",
              "context": "LCP diffuse désormais des films, comme Gomorra.",
              "idea": "Envoyer une pizza aux bloggers pour les informer et les inciter à relayer l’information sur les réseaux sociaux.",
              "meta": [
                {
                  "name": "Directeur de Création",
                  "value": "Eric Hélias"
                },
                {
                  "name": "Rédacteur",
                  "value": "Eric Hélias"
                },
                {
                  "name": "Direction Artistique",
                  "value": "Gregory Jeanjacquot"
                }
              ],
              "image": "gomorra.jpg",
              "images": [
                { "src": "/images/projects/LCP-gomorra-pizza.jpg"},
              ]
            },
            {
              "title": "L'Etudiant",
              "id": "letudiant",
              "date": "2O15",
              "context": "Campagne d’affichage pour le site letudiant.fr.",
              "idea": "Interpeler les étudiants sur les problèmes d’orientation.",
              "meta": [
                {
                  "name": "Directeur de Création",
                  "value": "Eric Hélias"
                },
                {
                  "name": "Rédacteurs (cosmonaute)",
                  "value": "Eric Hélias, Eric Lavenac"
                },
                {
                  "name": "Direction Artistique (cosmonaute)",
                  "value": "Guillaume Auboynaud"
                },
                {
                  "name": "Rédacteur (autres)",
                  "value": "Eric Hélias"
                },
                {
                  "name": "Direction Artistique (autres)",
                  "value": "Gregory Jeanjacquot"
                }
              ],
              "image": "etudiant.jpg",
              "images": [
                { "src": "/images/projects/etudiantCosmonaute.jpg"},
                { "src": "/images/projects/letudiantecrivain.jpg"},
                { "src": "/images/projects/letudiantagriculteur.jpg"},
                { "src": "/images/projects/letudiantstewart.jpg"},
                { "src": "/images/projects/letudiantattraction.jpg"},
                { "src": "/images/projects/letudiantlumiere.jpg"},
                { "src": "/images/projects/letudiantfootballeur3.jpg"},
              ]
            },
            {
              "title": "Bien-être & Santé",
              "id": "bien-etre-sante",
              "date": "2O15",
              "context": "À l’occasion du lancement d’une nouvelle formule, positionner le magazine Bien être & santé comme le leader de sa catégorie.",
              "idea": "Jouer sur le paradoxe de Bien-être & Santé, un gratuit acheté par les pharmaciens pour être donné à leurs clients.",
              "meta": [
                {
                  "name": "Directeur de Création",
                  "value": "Eric Hélias"
                },
                {
                  "name": "Rédacteur",
                  "value": "Eric Hélias"
                },
                {
                  "name": "Direction Artistique",
                  "value": "Gregory Jeanjacquot"
                }
              ],
              "image": "bien-etre.jpg",
              "images": [
                { "src": "/images/projects/BE&SVendu.jpg"},
              ]
            }
          ],
        },
      ]
    },
    {
      index: 2,
      url: '/ecommerce',
      title: 'E-Commerce',
      component: Gallery,
      desktopComponent: GalleryDesktop,
      items: [
        {
          "title": "E-Commerce",
          "id": "ecommerce",
          "image": "e-commerce.jpg",
          "items": [
            {
              "title": "Balsamik.fr",
              "id": "balsamik",
              "date": "2O15",
              "context": "Campagnes télés drive to web pour le site balsamik.fr, en partenariat avec l’agence LaFamilleXXL.",
              "idea": "La mode en ligne avec les femmes.",
              "meta": [
                {
                  "name": "Directeurs de Création",
                  "value": "Marion Vielfaure / Eric Hélias"
                },
                {
                  "name": "Rédacteur",
                  "value": "Eric Hélias"
                },
                {
                  "name": "Réalisation",
                  "value": "David Moreau"
                }
              ],
              "image": "e-commerce.jpg",
              "images": [
                { "src": "/images/projects/balsamik.mp4"},
                { "src": "/images/projects/balsamik2.mp4"},
              ]
            },
            {
              "title": "Venteprivée.com",
              "id": "vente-privee",
              "date": "2O15",
              "context": "Campagne d’image pour les 10 ans de Venteprivée.com.",
              "idea": "What’s in the box today ?",
              "meta": [
                {
                  "name": "Format",
                  "value": "2m 30"
                },
                {
                  "name": "Directeur de Création",
                  "value": "Eric Hélias"
                },
                {
                  "name": "Concepteur-rédacteur",
                  "value": "Eric Hélias"
                },
                {
                  "name": "Direction Artistique",
                  "value": "Grégory Jeanjacquot"
                },
                {
                  "name": "Réalisateur",
                  "value": "Erwin Olaff"
                }
              ],
              "image": "ventes-privees.jpg",
              "images": [
                { "src": "/images/projects/ventes-privees.mp4"},
              ]
            },
          ]
        },
        {
          "title": "Startups",
          "id": "startups",
          "image": "start-up.jpg",
          "items": [
            {
              "title": "Prêt à Pousser",
              "id": "pretapousser",
              "date": "2O16",
              "context": "Campagne d’affichage métro pour une start-up spécialisée dans les plantes, champignons et aromates qui poussent en intérieur.",
              "idea": "Jouer l’angle de la facilité, de l’inratable, avec pretàpousser tout le monde peut avoir la main verte.",
              "meta": [
                {
                  "name": "Directeur de Création",
                  "value": "Eric Hélias"
                },
                {
                  "name": "Rédacteur",
                  "value": "Eric Hélias"
                },
                {
                  "name": "Direction Artistique",
                  "value": "Oriane Marliac"
                }
              ],
              "image": "pretapousser.jpg",
              "images": [
                { "src": "/images/projects/TOURNESOL.jpg"},
                { "src": "/images/projects/LILO.jpg"},
                { "src": "/images/projects/BASILIC.jpg"},
                { "src": "/images/projects/CHAMPIGNONS.jpg"},
              ]
            },
            {
              "title": "Solendro",
              "id": "solendro",
              "date": "2O15",
              "context": "Campagne d’affichage métro pour une start-up spécialisée dans les ventes de sous-vêtement en ligne.",
              "idea": "Une campagne de « sexisme inversé « pour cette start-up qui voulait se faire connaitre par de l’affichage. ( X La Famille )",
              "meta": [
                {
                  "name": "Directeur de Création",
                  "value": "Marion Vielfaure / Eric Hélias"
                },
                {
                  "name": "Rédacteur",
                  "value": "Eric Hélias"
                },
                {
                  "name": "Direction Artistique",
                  "value": "Paméla Mitri"
                }
              ],
              "image": "start-up.jpg",
              "images": [
                { "src": "/images/projects/solendro1.jpg"},
                { "src": "/images/projects/solendro2.jpg"},
                { "src": "/images/projects/solendro3.jpg"},
                { "src": "/images/projects/solendro4.jpg"},
                { "src": "/images/projects/solendro5.jpg"},
                { "src": "/images/projects/solendro6.jpg"}
              ]
            },
            {
              "title": "Jobijoba",
              "id": "jobijoba",
              "date": "2O15",
              "context": "Campagne d’affichage métro pour une start-up spécialisée dans les annonces d’emploi en ligne.",
              "idea": "Inverser la convention qui veut que l’on cherche un emploi, alors qu’un million de jobs attendent preneur sur le site Jobijoba. (X La Famille)",
              "meta": [
                {
                  "name": "Format",
                  "value": "2m 30"
                },
                 {
                  "name": "Directeur de Création",
                  "value": "Marion Vielfaure / Eric Hélias"
                },
                {
                  "name": "Rédacteur",
                  "value": "Eric Hélias"
                },
                {
                  "name": "Direction Artistique",
                  "value": "Paméla Mitri"
                }
              ],
              "image": "jobijoba.jpg",
              "images": [
                { "src": "/images/projects/jobijoba1.jpg"},
                { "src": "/images/projects/jobijoba2.png"}
              ]
            }
          ]
        },
        {
          "title": "Contenu digital",
          "id": "contenu-digital",
          "image": "contenu-digital.jpg",
          "items": [
            {
              "title": "FFF / Spotify",
              "id": "fff-spotify",
              "date": "2O15",
              "context": "Création d’un partenariat entre la FFF et Spotify pour l’Euro 2012, la Playlist des Bleus.",
              "idea": "«Pour savoir ce que ton joueur préféré écoute et écouter les mêmes chansons que lui.»",
              "meta": [
                {
                  "name": "Conception",
                  "value": "Eric Hélias"
                }
              ],
              "image": "contenu-digital.jpg",
              "images": [
                { "src": "/images/projects/fff-spotify.jpg"},
              ]
            }
          ]
        },
        {
          "title": "Manifesto",
          "id": "manifesto",
          "image": "manifesto.jpg",
          "items": [
            {
              "title": "Lettre ouverte à la Mode",
              "id": "lettre-ouverte-a-la-mode",
              "date": "2O15",
              "context": "Lancement digital d’un web mag opinion / mode, complémentaire d’un site e-commerce.",
              "idea": "Rédaction d’une lettre ouverte à la mode, diffusée sur le web et en presse, écrite du point de vue d’une Quincado, terme que j’ai inventé pour qualifier les clientes ciblées par Balsamik.",
              "meta": [
                {
                  "name": "Rédacteur",
                  "value": "Eric Hélias"
                }
              ],
              "image": "manifesto.jpg",
              "images": [
                { "src": "/images/projects/manifesto.jpg"},
              ]
            }
          ]
        }
      ]

    },
    {
      index: 3,
      url: '/corporate',
      title: 'Corporate',
      component: Gallery,
      desktopComponent: GalleryDesktop,
      items: [
        {
          "title": "Marketing Territorial",
          "id": "marketing-territorial",
          "image": "marketing-territorial.jpg",
          "items": [
            {
              "title": "Pays d’APT",
              "id": "pays-apt",
              "date": "2O15",
              "context": "",
              "idea": "Création d’un label, Pays d’APT. Provence Préservée, pour la communauté de commune du Pays d’APT. Ce label a pour but de fédérer et de faire connaître toutes les richesses matérielles et immatérielles du Luberon.",
              "meta": [
                {
                  "name": "Concepteur",
                  "value": "Eric Hélias"
                },
                {
                  "name": "Directeur Artistique",
                  "value": "Oriane Marliac"
                }
              ],
              "image": "marketing-territorial.jpg",
              "images": [
                { "src": "/images/projects/APT.png"},
              ]
            }
          ]
        },
        {
          "title": "Ministère des droits de la femme",
          "id": "ministere-des-droits-de-la-femme",
          "image": "ministere-des-droits-femme.jpg",
          "items": [
            {
              "id": "ministere-des-droits-de-la-femme",
              "title": "Ministère des droits de la femme",
              "date": "2O15",
              "context": "Campagne film / print pour le Ministère des Droits de la Femme en faveur de la Mixité des Métiers en partenariat avec Citizen Républic.",
              "idea": "Au travail, c’est le talent qui compte.",
              "meta": [
                {
                  "name": "Directeur de Création",
                  "value": "Eric Hélias"
                },
                {
                  "name": "Conception",
                  "value": "Eric Hélias"
                },
                {
                  "name": "Direction Artistique",
                  "value": "Gregory Jeanjacquot"
                },
                {
                  "name": "Réalisateur / photographe",
                  "value": "Stéphane Barbato"
                }
              ],
              "image": "ministere-des-droits-femme.jpg",
              "images": [
                { "src": "/images/projects/Mixitedesmetiers55s.mp4"},
                { "src": "/images/projects/ministere-droit-femme.jpg"},
              ]
            }
          ]
        }


      ]

    },
    {
      index: 4,
      url: '/conseil',
      title: 'Conseil',
      component: Conseil,
      items: [
        {
          "title": "Lord of Barbes",
          "description": "Campagne de crowdfunding et lancement e-shop d’une nouvelle marque de gin premium",
          "images": [
            { "src": "/images/conseil/gin-lord-barbes.jpg"}
          ]
        },
        {
          "title": "Lebey",
          "description": "Conseil et critiques pour le guide gastronomique",
          "images": [
            { "src": "/images/conseil/couv-guide-lebey.jpg"},
            { "src": "/images/conseil/couv-guide-lebey.jpg"}
          ]
        },
        {
          "title": "Obadia-Stasi",
          "description": "Conseil en image pour le cabinet de droit pénal",
          "images": [
            { "src": "/images/conseil/obadia-stasi.jpg"}
          ]
        },
        {
          "title": "Telosvoyages",
          "description": "Conseil et conception d’un livre sur l’Incentive",
          "images": [
            { "src": "/images/conseil/incentive.png"}
          ]
        }
      ]
    },
    {
      index: 5,
      url: '/about',
      title: 'À propos',
      component: About
    },
    {
      index: 6,
      url: '/philosophie',
      title: 'Philosophie',
      component: Philosophy
    },
    {
      index: 7,
      url: '/contact',
      title: 'Contact',
      component: Contact
    }
  ],

  about: {
    title: 'about',
    body: `
      I began my career in 2010 at Publicis Nurun during 3 years as an Junior Art Director  where I had the privilege to work with famous Brand like Hermès, Cartier, Carrefour, Special.T, Givenchy and more.
    `
  },
  contact: {
    title: 'contact',
    body: `
      For work inquiries,<br/>
      please email:<br/>
      hi@sitename.com
    `
  },

}



/** WEBPACK FOOTER **
 ** ./src/data.js
 **/